/**
 * subject-context-search-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

import { Result } from "../../../search/search.service";

/**
 * The server sends a {@link SubjectContextSearchResponse} in response to a
 * client query. The message contains the set of all subject contexts matching
 * the given query.
 */
@validateFor(MessageTag.RSP_SUBJECT_CONTEXT_SEARCH)
export class SubjectContextSearchResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SUBJECT_CONTEXT_SEARCH;

  /**
   * The array of results returned by the user search query.
   */
  @validateAs({array: "object"}) // TODO: improve
  public resultSet : Result[];

  /**
   * Whether the server has indicated that there are more results beyond those
   * returned (but which were limited due to configuration / resources).
   */
  @validateAs("boolean", true, false)
  public canGetMoreData : boolean;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/search/subject-context-search-response.ts